import { AppState } from "store";
import { TagLibraryFiltersArgs } from "./types";

export const tagLibraryFiltersSelector = ({
  filters,
}: AppState): TagLibraryFiltersArgs => {
  return filters.tagLibrary;
};
